module.exports = __webpack_public_path__ + "static/media/ecomm.9138f467.png";